module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "role": "menu"
    }
  }, [_c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "modalSesc",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "modalSescLabel"
    }
  }, [_c('div', {
    staticClass: "modal-dialog",
    attrs: {
      "role": "document"
    }
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row row-field",
    staticStyle: {
      "padding-bottom": "15px"
    }
  }, [_c('div', {
    staticClass: "col-md-12 col-sm-12"
  }, [_vm._m(1), _vm._m(2), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', [_vm._v("\n                Caso o limite de 300 (trezentas) inscrições/mês seja alcançado no prazo de 48 horas, o servidor\n                deverá aguardar o próximo período para inscrever-se novamente, por não haver lista de espera.\n              ")]), _vm._v(" "), _c('br'), _vm._v(" "), _vm._m(3), _vm._m(4), _vm._v(" "), _c('p'), _vm._v(" "), _vm._m(5), _vm._m(6), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.baixaArquivo('Manual_MIS_7.0.pdf')
      }
    }
  }, [_vm._v("Acessar Manual")]), _vm._v(" "), _c('p'), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        return _vm.baixaArquivo('descontados-mes.pdf')
      }
    }
  }, [_vm._v("Acessar lista")])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('botao', {
    attrs: {
      "estilo": "cheio-verde",
      "rotulo": "OK",
      "icone": "ok-modal",
      "dismiss": "modal"
    }
  })], 1)])])]), _vm._v(" "), _c('nav', {
    staticClass: "navbar navbar-default"
  }, [_c('div', {
    staticClass: "container",
    staticStyle: {
      "padding-left": "0px"
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    class: _vm.declaracaoAtiva,
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("Declarações")]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'DeclaracaoBens'
      }
    }
  }, [_vm._v("Declaração de Bens")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Dependente'
      }
    }
  }, [_vm._v("Parceiro Econômico")])], 1)])]), _vm._v(" "), _c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    class: _vm.avaliacaoAtiva,
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("Avaliações")]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Avaliacao'
      }
    }
  }, [_vm._v("Avaliação Periódica")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'AvaliacaoEstagioProbatorio'
      }
    }
  }, [_vm._v("Estágio Probatório")])], 1)])]), _vm._v(" "), _c('li', [_c('a', {
    staticClass: "dropdown-toggle",
    class: _vm.recadastramentoAtiva,
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("Atualização Cadastral")]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'MesCompetenciaOrdenado'
      }
    }
  }, [_vm._v("Dados Pessoais")])], 1)])]), _vm._v(" "), _c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    class: _vm.feriasAtiva,
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("Férias")]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Ferias'
      }
    }
  }, [_vm._v("Agendamento de Férias\n                ")])], 1), _vm._v(" "), (_vm.ehResponsavelAprovador) ? _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Aprovacao'
      }
    }
  }, [_vm._v("\n                  Aprovação de Férias\n                ")])], 1) : _vm._e()])]), _vm._v(" "), (_vm.valeAlimentacaoHabilitado) ? _c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    class: _vm.valeAlimentacaoAtiva,
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("Vale-Alimentação")]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'ValeAlimentacao'
      }
    }
  }, [_vm._v("Escolha do Vale-Alimentação\n                ")])], 1)])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    class: _vm.formulariosAtiva,
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("Formulários")]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'FaltaLei'
      }
    }
  }, [_vm._v("Falta Lei")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'DeclaracaoInclusaoImpostoRenda'
      }
    }
  }, [_vm._v("Declaração de Inclusão IR")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'DeclaracaoExclusaoImpostoRenda'
      }
    }
  }, [_vm._v("Declaração de Exclusao IR")])], 1)])]), _vm._v(" "), _vm._m(8)])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title",
    attrs: {
      "id": "modalSescLabel"
    }
  }, [_vm._v("\n            Credenciamento Prefeitura de Santos - SESC\n          ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("\n                Olá!"), _c('br'), _c('br'), _vm._v("\n\n                Esta ação de Credenciamento do Sesc é exclusiva para os servidores ativos da Prefeitura\n                Municipal de Santos e ficará disponível para preenchimento a partir das 10h30 do 1º dia útil do\n                mês (exceto segundas-feiras), por 48 horas, ou até atingir o limite permitido no contrato, a saber,\n                300 inscrições/mês.\n                "), _c('br'), _c('br'), _vm._v(" "), _c('strong', [_vm._v("Para acessar o link do formulário, faz-se necessário “atualizar os dados de navegação”,\n                ")]), _vm._v("\n                limpando o histórico de seu navegador, preferindo computadores ou notebook.\n                "), _c('br'), _c('br'), _vm._v("\n                Após o período de preenchimento, os dados serão validados pela Prefeitura Municipal de Santos,\n                a qual procederá com "), _c('strong', [_vm._v("desconto único anual")]), _vm._v(" na folha de pagamento no valor\n                de R$40,00 (quarenta reais), referente ao credenciamento do titular.\n                "), _c('br'), _c('br'), _vm._v("\n                Para ativar sua credencial MIS digital, você receberá um SMS recomendando a instalação do\n                aplicativo “Credencial Sesc SP” (iOS ou Android). Desta forma é OBRIGATÓRIO informar seu\n                número de celular e aceitar o recebimento de SMS durante o preenchimento deste formulário.\n                Lembramos que a credencial MIS tem validade de 1 (um) ano, com abrangência no estado de\n                São Paulo e não cria vínculo com o Sesc, assim como não concede os mesmos benefícios\n                oferecidos aos trabalhadores do Comércio de Bens, Serviços e Turismo.\n                "), _c('br'), _c('br'), _vm._v("\n                Para iniciarmos o processo de credenciamento MIS, tenha em mãos seus documentos pessoais\n                (RG, CPF e uma foto).\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('br'), _vm._v("Importante! "), _c('br'), _c('br'), _vm._v("\n                O não preenchimento dos dados, assim como o preenchimento incompleto, serão considerados\n                como inconsistência cadastral.\n              ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("\n                  Link do formulário eletrônico de inscrição para credenciamento dos servidores da\n                  Prefeitura Municipal de Santos:\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Acesso:")]), _c('br'), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://form.jotform.com/241063912551652"
    }
  }, [_vm._v("https://form.jotform.com/241063912551652")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('br')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Manual para cadastramento no sistema do SESC, contendo perguntas e respostas\n                  frequentes:\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('br'), _vm._v(" "), _c('strong', [_vm._v("\n                  Lista contendo Nome e Registro dos servidores contemplados no último mês (os quais\n                  deverão AGUARDAR desconto na folha de pagamento, bem como contato do SESC através\n                  de SMS para efetivação do credenciamento no App Credencial Sesc SP, podendo baixar\n                  desde já):\n                ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "dropdown"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "dropdown",
      "role": "button",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_vm._v("Links")]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "https://egov.santos.sp.gov.br/jornada",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil-square-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                   Jornada\n                ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://egov.santos.sp.gov.br/jornada/downloads/manual.pdf",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('i', {
    staticClass: "fa fa-book",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                   Manual\n                ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://egov.santos.sp.gov.br/jornada/downloads/formularios.docx",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('i', {
    staticClass: "fa fa-file-text-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                   Anexo Único\n                ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://entrega.santos.sp.gov.br",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('i', {
    staticClass: "fa fa-cloud-upload",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                   Entrega\n                ")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://webmail.santos.sp.gov.br",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('i', {
    staticClass: "fa fa-envelope-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                   WebMail\n                ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://egov.santos.sp.gov.br/sigm_web_adm_sistema",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('i', {
    staticClass: "fa fa-stethoscope",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                   Perícia Médica\n                ")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://egov.santos.sp.gov.br/contador",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('i', {
    staticClass: "fa fa-usd",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                   Holerite\n                ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://egov.santos.sp.gov.br/contador",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('i', {
    staticClass: "fa fa-paw",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                   Informe de Rendimentos\n                ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://egov.santos.sp.gov.br/contador",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('i', {
    staticClass: "fa fa-clock-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                   Contagem de Tempo\n                ")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://egov.santos.sp.gov.br/legis/documents/55",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('i', {
    staticClass: "fa fa-balance-scale",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                   Estatuto\n                ")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "https://www.santos.sp.gov.br/portal/servidor",
      "target": "_blank",
      "rel": "noopener"
    }
  }, [_c('i', {
    staticClass: "fa fa-globe",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n                   Portal do Servidor\n                ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-520919a3","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/barra-menu/index.vue
// module id = UmM+
// module chunks = 5